<div class="colmec-login-reset-password-container">
  <div class="row box-container">
    <div class="col-12 col-md-6 logo-container">
      <img src="./assets/logov2.png" alt="Logotype" class="colmec-login-reset-password-logo" />
    </div>
  </div>
  <div class="row colmec-login-reset-password-box">
    <div class="col-12 col-md-8 colmec-login-reset-password-bg-img d-flex justify-content-center">
      <div class="d-flex align-items-center">
        <div class="content-info">
          <div class="white-text-style medium-size text-uppercase" translate>UNIQUE_TOTAL_CONCEPT</div>
          <div class="big-text-style text-primary" translate>SAFE_LAZY</div>
          <div class="big-text-red-style" translate>FUNCTIONAL_PARTNER</div>
          <div class="white-text-style small-size" translate>PRODUCTS_SERVICES_SERVICE_SUPPORT</div>
          <div class="white-text-style small-size" translate>BEST_QUALITY</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4 d-flex align-items-center justify-content-center">
      <div *ngIf="isLogin; else resetPassword">
        <colmec-login></colmec-login>
      </div>
      <ng-template #resetPassword>
        <div class="colmec-reset-password-container">
          <lib-forgot-password></lib-forgot-password>
        </div>
      </ng-template>
    </div>
  </div>
</div>
